import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { ExcelService } from 'src/app/services/excel.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { LoaderService } from 'src/app/shared/services/loader.service';

@Component({
  selector: 'app-vumatel-product-mapping',
  templateUrl: './vumatel-product-mapping.component.html',
  styleUrls: ['./vumatel-product-mapping.component.scss']
})
export class VumatelProductMappingComponent implements OnInit {
  data: any= [];
  dataExcel: any = [];
  excelColumns: string[];
  myForm: FormGroup;
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "HCProduct",
    "VumatelBaseProduct",
    "12MonthProduct",
    "action"
  ];
  VumatelProduct: any;
  Products: any[] = [];
  MonthProducts: any[] = [];
  filteredListBaseProduct: any[] = [];
  filteredListMonthProduct: any[] = [];
  vumatelp: any[] = [];
  productv: any[] = [];
  Vumatellist: any;
  selectedValues: any;

  constructor(
    private LookupDataService: LookupDataServiceService, 
    private _formBuilder: FormBuilder,
    private ApplicationDataService:ApplicationDataService,
    private toastr: NotificationService,
    private loaderService: LoaderService,
    private excelService: ExcelService,


  ) { }

  ngOnInit(): void {
    this.myForm = this._formBuilder.group({
      productid: [],
      productName: [],

    });
    this.getVumatelProductFromAPI();
    this.getVumatelProducts();
    this.getVumatelProductMapping();
  }

  async getVumatelProductFromAPI() {
    await this.LookupDataService.getVumatelProductFromAPI().subscribe((result) => {
      this.MonthProducts = result.map((item: any) => item);
      this.filteredListMonthProduct = [...this.MonthProducts];
      this.Vumatellist = result.map((item: any) => item);
      this.filteredListBaseProduct = [...this.Vumatellist];
    });
  }

  async getVumatelProducts() {
    await this.LookupDataService.getVumatelProducts().subscribe(result => {
      this.vumatelp = result;
      this.dataExcel = result;
console.log('vumurp',result)
      this.VumatelProduct = result.map((item: any) => item.aliasName);
      this.data = result.map(product => ({
        productid: product.id,
        VumatelProduct: product.productName,
        VumatelBaseProduct: '',
        MonthProduct: ''
      }));
      this.dataSource.data = this.data;
    });
  }

  async getVumatelProductMapping() {
    await this.LookupDataService.getVumatelProductMapping().subscribe(result => {
      this.productv = result;
      console.log('productv',result)

      setTimeout(() => {
        this.updateProductMappings();
      }, 1000);
    });
  }

  updateProductMappings(): void {
 
    this.productv.forEach(itemVPM => {
      this.vumatelp.forEach(itemCollection => {
        if (itemCollection.id === itemVPM.actualProductId) {
          itemCollection.vumatelProductName = itemVPM.vumatelProductName??'';
          itemCollection.monthlyProduct = itemVPM.monthlyProduct??'';
          
          if (itemVPM.vumatelProductName && itemVPM.actualProductId === itemCollection.id) {
            this.data.forEach(dataItem => {
              if (dataItem.VumatelProduct === itemCollection.productName && dataItem.productid === itemCollection.id) {
                dataItem.productid = itemCollection.id;
                dataItem.VumatelBaseProduct = itemVPM.vumatelProductName;
                dataItem.MonthProduct = itemCollection.monthlyProduct;
              }
            });
          }
        }
      });
    });
    
    



    console.log(this.data);

    this.dataSource.data = [...this.data];


  }



  exportAsXLSX() {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        "HC Product",
        "Vumatel Base Product",

      ];
      exportData.forEach((a, index) => {
        excelList.push({
          sno: ++index,
          "HC Product":a.aliasName,
          "Vumatel Base Product":a.vumatelProductName,

        });
      });
      this.excelService.exportAsExcelFile(excelList, "Product_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }

  clearFilter() {
    this.getVumatelProducts();
    this.getVumatelProductMapping();
  }



  save(product: any, Productid: any,VumatelBaseProduct:any,MonthProduct:any) {
    var postData: any = {};
    postData.actualProductId = Productid;
    postData.actualProductName = product
    postData.vumatelProductName = VumatelBaseProduct;
    postData.monthlyProduct = MonthProduct;
    console.log(postData)
    if(postData.VumatelBaseProduct || postData.monthlyProduct)
    this.ApplicationDataService.saveVumatelProductMapping(postData).subscribe((result)=>{
      console.log(result);
      if(result)
    this.toastr.showSuccess("Saved Successfully");
  else
  this.toastr.showSuccess("Failed to Saved");


    })
  }
}
